<template>
  <div>
    <div v-show="isLoading" class="loader">
      <b-spinner class="align-middle mb-3" />
      <strong>Loading...</strong>
    </div>

    <div v-show="!isLoading">
      <div v-if="importResult?.failed_count === 0" class="card p-4">
        <div class="success text-center">
          <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
          <h5 class="mt-2 mb-3">
            {{ $t('global.importResult.successUpload') }}
          </h5>
          <p>{{ $t('master.customer.upload.successUpload.subtitle') }}</p>
        </div>
      </div>

      <template v-else>
        <McAlert
          withIcon
          variant="error"
          class="alert-error mb-4"
          :text="$t('global.importResult.invalidTemplate')"
        />
        <b-tabs v-model="activeTab" lazy>
          <b-tab title="Informasi Pelanggan" class="card p-4">
            <Table :fields="customerInfoFields" :listGetter="fetchData" />
          </b-tab>
          <b-tab title="Daftar Kontak" class="card p-4">
            <Table :fields="contactFields" :listGetter="fetchData" />
          </b-tab>
          <b-tab title="Catatan Pengiriman" class="card p-4">
            <Table :fields="deliveryNotesFields" :listGetter="fetchData" />
          </b-tab>
        </b-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import uploadSuccessImg from '@/assets/images/upload-success.png'

import McAlert from '@/components/McAlert'
import Table from '../components/Table'

import { customerInfoFields, contactFields, deliveryNotesFields } from '../lib/uploadResultFields'

import { getImportResult } from '@/services/rest-api/lib/customer/import'

const resourceTypes = ['customer', 'customer_delivery_note', 'customer_contact']

export default {
  components: {
    Table,
    McAlert,
  },
  inject: ['importResult', 'resetImportResult', 'setImportResult'],
  data() {
    return {
      activeTab: 0,
      customerInfoFields,
      contactFields,
      isLoading: false,
      uploadSuccessImg,
      deliveryNotesFields,
    }
  },
  beforeDestroy() {
    this.resetImportResult()
  },
  methods: {
    async fetchData(opts) {
      // For showing initial loader
      if (!this.importResult) {
        this.isLoading = true
      }

      const res = await getImportResult(this.$route.params.id, {
        ...opts,
        resource: resourceTypes[this.activeTab],
        format: 'json',
      })

      if (!res || res.errors) return

      // Only set metadata on initial load
      if (!this.importResult) {
        const { failed_count, success_count, processed_count } = res.metadata
        this.setImportResult({
          failed_count,
          success_count,
          total_count: processed_count,
        })
      }

      this.isLoading = false

      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.alert-error {
  width: fit-content;
}

.loader {
  min-height: min(50vh, 500px);
  display: grid;
  place-items: center;
  place-content: center;
  background-color: white;
}
</style>
